import { render, staticRenderFns } from "./records2.vue?vue&type=template&id=fbc920a6&scoped=true"
import script from "./records2.vue?vue&type=script&lang=js"
export * from "./records2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc920a6",
  null
  
)

export default component.exports